export default {
  userDropDown: {
    userInfo: '个人信息',
    changePW: '修改密码',
    logOut: '退出登录',
  },
  changePW: {
    changePW: '修改密码',
    oldPW: '旧密码',
    newPW: '新密码',
    confirmPW: '确认新密码',
    change: '确认',
    cancel: '取消',
  },
};
